export function assertUnreachable(_: never) {
  throw new Error(`This point should be unreachable. Reached with value ${_}`);
}
